<template>
  <label class="relative">
    <search-icon class="pointer-events-none absolute h-full w-8 p-2 text-gray-50" />
    <ui-input
      v-model.trim="val"
      :data-testid="dataTestid"
      :small="small"
      :light="light"
      :class="[small ? '!px-8' : '!px-9', !val && '!pr-2']"
      :placeholder="placeholder || $t('universal.search')"
      :shrinkable-placeholder="shrinkablePlaceholder"
      :aria-label="placeholder || $t('universal.search')"
    />
    <button v-if="val" type="button" @click="clearInput">
      <x-icon class="hover:text-gray-60 absolute right-0 top-0 h-full w-8 cursor-pointer p-2 text-gray-50" />
    </button>
  </label>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { debounce } from 'lodash-es'
import { UiInput } from '@klausapp/ui-kit'
import { SearchIcon, XIcon } from '@klausapp/ui-kit/icons'
import { sanitize } from '@/utils/sanitize'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    small?: boolean
    dataTestid?: string
    debounceTimeout?: number
    placeholder?: string
    shrinkablePlaceholder?: boolean
    light?: boolean
  }>(),
  { debounceTimeout: 0 },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const val = ref(props.modelValue || '')

const emitUpdate = debounce((val) => emit('update:modelValue', sanitize(val)), props.debounceTimeout)

watch(val, () => emitUpdate(val.value))
watch(
  () => props.modelValue,
  () => (val.value = props.modelValue),
)

const clearInput = () => {
  val.value = ''
}
</script>
